import React from "react";
import ProjectMain from 'components/privatedb/list/main'
import ProjectCreate from "./details/create";
import PrivateDBDetails from "./details/details";
import PrivateDBEdit from './details/edit';
import PrivateDBAssign from './details/assign';
import Errors from 'components/error404';
import { ProjectDetailsRoutes } from "./details/routes";

export function PrivateDBRoutes() {
    return [
        {
            path: '',
            element: (<ProjectMain />),
            errorElement: <Errors />,
        },
        {
            path: 'list',
            element: (<ProjectMain />),
            errorElement: <Errors />,
        },
        {
            path: 'create',
            element: (<ProjectCreate />),
            errorElement: <Errors />,
        },
        {
            path: 'details/assign/:id',
            element: (<PrivateDBAssign />),
            errorElement: <Errors />,
            //children: ProjectDetailsRoutes()
        },
        {
            path: 'details/:id',
            element: (<PrivateDBDetails />),
            errorElement: <Errors />,
            //children: ProjectDetailsRoutes()
        },

        {
            path: 'edit/:id',
            element: (<PrivateDBEdit />),
            errorElement: <Errors />
        }
    ]
}

export default PrivateDBRoutes;